import MerchantService from '../services/MerchantService';
import ErrorHandler from '../helpers/ErrorHandler';
import {NotificationManager} from 'react-notifications';
import MerchantConstants from '../constants/MerchantConstants';
import {hashHistory} from 'react-router';

export default {
  get: () => dispatch => {
    dispatch({type: 'ON_BUSY'});
    MerchantService.get().then((response) => {
      var merchant = Object.assign({}, response.merchant);
      for (var item in response.merchant) {
        if (response.merchant.hasOwnProperty(item)) {
          merchant[item] = merchant[item] !== null ? merchant[item] : '';
        }
      }
      dispatch({type: 'OFF_BUSY'});
      dispatch({
        type: MerchantConstants.MERCHANT_SET_USER,
        payload: merchant
      });
      dispatch({
        type: MerchantConstants.SET_PROFILE_FORM,
        payload: merchant
      });
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err)
    })
  },

  getMerchantWithTypes: () => dispatch => {
    dispatch({type: 'ON_BUSY'});
    MerchantService.get().then((response) => {
      var merchant = Object.assign({}, response.merchant);
      for (var item in response.merchant) {
        if (response.merchant.hasOwnProperty(item)) {
          merchant[item] = merchant[item] !== null ? merchant[item] : '';
        }
      }
      MerchantService.getTypes().then((response) => {
        merchant.types = response.merchant_types;
        dispatch({
          type: MerchantConstants.SET_PROFILE_FORM,
          payload: merchant
        });
        dispatch({type: 'OFF_BUSY'});
      }, (err) => {
        dispatch({type: 'OFF_BUSY'});
        ErrorHandler(err)
      });
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err)
    })
  },
  getMerchantTypes: () => dispatch => {
    dispatch({type: 'ON_BUSY'});
    MerchantService.getTypes().then((response) => {
      dispatch({
        type: MerchantConstants.MERCHANT_GET_TYPES,
        payload: response
      });
      dispatch({type: 'OFF_BUSY'});
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err)
    });
  },
  edit: (dataMerchant, openHours) => dispatch => {
    if (dataMerchant.confirm_password !== dataMerchant.password) {
      NotificationManager.error(`Password does not match.`);
      return;
    }
    dispatch({type: 'ON_BUSY'});
    MerchantService.updateMerchant(dataMerchant, openHours).then((response) => {
      dispatch({type: 'OFF_BUSY'});
      dispatch({
        type: MerchantConstants.MERCHANT_SET_USER,
        payload: response.merchant
      });
      hashHistory.push('/merchant_info');
      NotificationManager.success(`Changes saved.`);
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err);
    })
  }
}


/** WEBPACK FOOTER **
 ** ./src/actions/MerchantAction.js
 **/